export default __webpack_public_path__ + "static/media/8.d8deae60.jpg";